import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonRu from "@/locales/ru/common.json";

/**
 * i18next bootstrap. UI_PLAN §2.7 — RU-only in v1, but architected for en/etc.
 * No language detector (NFR-3: locale is fixed). Adding a new locale = new
 * resource bundle + flip `lng`.
 */

export const SUPPORTED_LOCALES = ["ru"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_NAMESPACE = "common";

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: {
      ru: { common: commonRu },
    },
    lng: "ru",
    fallbackLng: "ru",
    defaultNS: DEFAULT_NAMESPACE,
    ns: [DEFAULT_NAMESPACE],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnNull: false,
  });
}

export { i18n };
